import {NotificationContextBar} from '@/features/notifications/components/notification-context-bar/NotificationContextBar'
import {useNotificationContextHostStore} from '@/features/notifications/store/useNotificationContextHostStore'
import {StyledNotificationContextBarRow} from './style'

/**
 * Mounts the wide form of the work-context bar once, in PrivateLayout's reserved row.
 *
 * The row element is always rendered so `<Outlet />` keeps its own grid row; it collapses to
 * zero height whenever the bar has nothing to show — either because there is no work context,
 * or because a surface on screen has claimed the bar and renders it inside itself.
 */
export const NotificationContextBarHost = () => {
    const hostId = useNotificationContextHostStore(state => state.hostId)

    return (
        <StyledNotificationContextBarRow>
            {hostId === null && <NotificationContextBar variant="wide" />}
        </StyledNotificationContextBarRow>
    )
}
